"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.whenRouterChange = whenRouterChange;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.sort");

var firebase = _interopRequireWildcard(require("firebase/app"));

var _lodash = _interopRequireDefault(require("lodash"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _utils = require("../utils");

var _runtime = _interopRequireDefault(require("../utils/runtime"));

var _storage = _interopRequireDefault(require("../utils/storage"));

var _transport = require("../transport");

var _device = require("../utils/device");

var _path = require("../utils/path");

var _compatibility = require("../compatibility");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TDigest = require('tdigest').TDigest;

var digest = new TDigest();
var timeList = [];
var N = 10; //阀值

var LAG_FLAG = 100; //ms

var LOCAL_STORAGE_NAME = 'LOCAL_STORAGE_ACTION_3ef705fd12';
var metrics; //初始化进来

function init() {
  (0, _utils.tryCall)(function () {
    return clickMonitor();
  }, false); // 初始化检查数据

  checkLocalStorageData(); //离开页面检查数据

  window.addEventListener("beforeunload", function () {
    if (metrics) {
      _storage.default.set({
        key: LOCAL_STORAGE_NAME,
        metrics: metrics,
        url: (0, _path.getUrl)()
      });
    }
  });
} //路由变化进来


function whenRouterChange() {
  // API 兼容性检查
  if (!window.performance || !window.localStorage) {
    return false;
  }

  checkLocalStorageData();
}

function clickMonitor() {
  window.addEventListener('ontouchstart' in window ? 'touchstart' : 'click', function (e) {
    var diffTime = (performance.now ? performance.now() : Date.now()) - e.timeStamp;
    timeList.push(diffTime);

    if (timeList.length === N) {
      var X = timeList.splice(0, N).sort();
      var count = X.filter(function (i) {
        return i > LAG_FLAG;
      }).length;
      digest.push(X);
      digest.compress();
      metrics = {
        count: count,
        lag_precent: (0, _utils.getThreeDecimals)(count / X.length),
        response_50: (0, _utils.getThreeDecimals)(digest.percentile(0.5)),
        response_90: (0, _utils.getThreeDecimals)(digest.percentile(0.9)),
        response_95: (0, _utils.getThreeDecimals)(digest.percentile(0.95)),
        response_99: (0, _utils.getThreeDecimals)(digest.percentile(0.99))
      };
    }
  }, true);
  return true;
}

function checkLocalStorageData() {
  var storageDataStr = _storage.default.get({
    key: LOCAL_STORAGE_NAME
  });

  if (storageDataStr) {
    var data = JSON.parse(storageDataStr);
    record(data);

    _storage.default.clear({
      key: LOCAL_STORAGE_NAME
    });
  } //路由切换是可以拿到当前页面的数据


  if (metrics) {
    // storage.set({key: LOCAL_STORAGE_NAME, metrics, pathname: window.location.pathname})
    record({
      metrics: metrics
    });
  }
}

function record(_ref) {
  var metrics = _ref.metrics,
      url = _ref.url;
  var pathname;

  if (url) {
    pathname = (0, _urlParse.default)(url).pathname;
  }

  (0, _transport.transport)({
    endPoints: [_constants.FIREBASE_ENDPOINT_NAME, _constants.PROMETHEUS_ENDPOINT_NAME],
    type: 'action',
    url: url,
    traceName: "action_".concat((0, _path.getRouteName)(pathname)),
    message: {
      metrics: _objectSpread({
        duration: metrics.response_50
      }, _lodash.default.pick(metrics, ['response_90', 'response_95', 'response_99', 'lag_precent'])),
      attributes: {
        device_level: (0, _device.getDeviceLevel)()
      }
    }
  });
}